precision highp float;

varying vec2 vUv;
uniform sampler2D prevTex;
uniform vec2 cursor;
uniform vec2 prevCursor;
uniform vec2 resolution;
uniform float decay; 
uniform float splatRadius;
uniform float splatStrength;
uniform float advectStrength;
uniform float time;
uniform float minDecay;


vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec2 mod289(vec2 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec3 permute(vec3 x) { return mod289(((x*34.0)+1.0)*x); }

float snoise(vec2 v) {
    const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
    vec2 i  = floor(v + dot(v, C.yy));
    vec2 x0 = v -  i + dot(i, C.xx);
    vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
    vec4 x12 = x0.xyxy + C.xxzz;
    x12.xy -= i1;
    i = mod289(i);
    vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
    vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
    m = m*m; m = m*m;
    vec3 x = 2.0 * fract(p * C.www) - 1.0;
    vec3 h = abs(x) - 0.5;
    vec3 ox = floor(x + 0.5);
    vec3 a0 = x - ox;
    m *= 1.79284291400159 - 0.85373472095314 * (a0*a0 + h*h);
    vec3 g;
    g.x  = a0.x  * x0.x  + h.x  * x0.y;
    g.yz = a0.yz * x12.xz + h.yz * x12.yw;
    return 130.0 * dot(m, g);
}

float fbm(vec2 uv) {
    float val = 0.0;
    float amp = 0.5;
    for (int i = 0; i < 3; i++) {
        val += amp * snoise(uv);
        uv *= 2.1;
        amp *= 0.5;
    }
    return val;
}

void main() {
    vec2 uv = vUv;
    vec2 aspect = vec2(resolution.x / resolution.y, 1.0);

    float mouseSpeed = length(cursor - prevCursor);
    float movementFactor = smoothstep(0.0001, 0.004, mouseSpeed);
    vec2 mouseVelocity = (cursor - prevCursor) * advectStrength;
    float warp = snoise(uv * 2.0 + time * 0.1);

    float n  = fbm(uv * 3.0 + warp + time * 0.08);
    float n2 = fbm(uv * 6.0 - warp * 0.5 - time * 0.12);
    vec2 curl = vec2(n, n2) * 0.006;
    vec2 advectedUV = uv - (mouseVelocity * 0.25) - (curl * mix(0.4, 1.0, movementFactor));
    vec4 frame = texture2D(prevTex, advectedUV);
    float d = distance(uv * aspect, cursor * aspect);
    float noiseDetail = fbm(uv * 12.0 + time * 0.2);
    float radiusDistortion = (1.0 + noiseDetail * 0.7 * movementFactor);
    float m = (splatRadius * radiusDistortion) / (d + 0.0001);
    float splat = pow(clamp(m, 0.0, 1.0), 4.0) * splatStrength * movementFactor;
    vec2 texel = 1.0 / resolution;
    float avg = (
        texture2D(prevTex, uv + vec2(texel.x, 0.0)).r +
        texture2D(prevTex, uv - vec2(texel.x, 0.0)).r +
        texture2D(prevTex, uv + vec2(0.0, texel.y)).r +
        texture2D(prevTex, uv - vec2(0.0, texel.y)).r
    ) * 0.25;

    float finalDensity = mix(frame.r, avg, 0.25);
    finalDensity += splat;

    float distToCursor = distance(uv * aspect, cursor * aspect);
    float proximityMask = 1.0 - smoothstep(0.0, 0.15, distToCursor);
    float baseDecay = mix(decay * 0.965, decay, movementFactor);
    float spatialDecay = mix(baseDecay, minDecay, proximityMask);
    finalDensity *= spatialDecay;

    float tailCutoffSpeed = 0.004; // długość ogona - czym mniejsza tym dluższy
    finalDensity -= tailCutoffSpeed;

    finalDensity = max(finalDensity, 0.0);
    float grad = length(vec2(dFdx(finalDensity), dFdy(finalDensity))); // !!! szklisty 3D bump
    float display = finalDensity + grad * 0.62;

    gl_FragColor = vec4(vec3(clamp(display, 0.0, 1.0)), 1.0);
    }